<template lang="pug" src="./google.pug"></template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

  export default{
    name: 'GoogleMB',
    data(){
      return{
        rating: "0.0",
        reviews: '0',
        showError: false,
        numReviews: 5,
        btShowing: true,
        items: [{}],
        address: ''
      }
    },
    methods: {
      ...mapGetters(['isTokenSet']),
      ...mapActions(['getGoogleInfo']),
      async getGoogle(){
        await this.getGoogleInfo({
          identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
        })
        this.items = this.googleInfo
        //console.log(JSON.stringify(this.items.result,null,2))
        if(this.items.result){
          this.showError = false
          this.rating = this.items.result.rating
          this.reviews = this.items.result.reviews.length
        }else{
          this.showError = true
        }

      },
      showLessReviews(){ this.btShowing = true; this.numReviews = 5 },
      showMoreReviews(){ this.btShowing = false; this.numReviews = 10 }

    },
    computed: {

        selectedHs () {
          return this.$store.state.adminHotspots.selectedHotspot
        },

        googleInfo(){
          return this.$store.state.adminSocial.googleData
        },

        limitedReviews(){
          return this.items.result.reviews.slice(0, this.numReviews)
        }
    },
    created () {
      this.getGoogle()
    },

    watch: {
      selectedHs () {
        this.getGoogle()
      }
    }
  }
</script>
